/**
 * meetingCorridors.js
 * Data definitions for 8 meeting overlap corridors.
 */

export const MEETING_CORRIDORS = [
  {
    slug: 'us-india',
    h1: 'Best Meeting Times Between the US and India',
    regionA: 'United States (EST/PST)',
    regionB: 'India (IST)',
    ianaA: 'America/New_York',
    ianaB: 'Asia/Kolkata',
    citiesA: 'New York / San Francisco',
    citiesB: 'Mumbai / Bangalore / Delhi',
    recommendedWindow: '08:00–10:00 AM EST (06:30–08:30 PM IST) or 08:00–09:00 PM EST (06:30–07:30 AM IST next day).',
    overlapType: 'No shared 09:00–17:00 hours for New York and India',
    fairnessAdvice: 'Alternate early morning US calls with evening US calls so neither the Indian team nor the US team bears 100% of out-of-hours meetings.',
    contextCopy: '',
  },
  {
    slug: 'us-philippines',
    h1: 'Best Meeting Times Between the US and the Philippines',
    regionA: 'United States (EST/PST)',
    regionB: 'Philippines (PHT)',
    ianaA: 'America/New_York',
    ianaB: 'Asia/Manila',
    citiesA: 'New York / Los Angeles',
    citiesB: 'Manila / Cebu',
    recommendedWindow: '08:00–10:00 PM EST (09:00–11:00 AM PHT next day).',
    overlapType: 'Shift-Based / Night-Shift Overlap',
    fairnessAdvice: 'Many Philippine BPO & tech teams work night shifts aligned with US business hours. For standard daytime teams, evening US calls catch Manila morning.',
    contextCopy: '',
  },
  {
    slug: 'us-europe',
    h1: 'Best Meeting Times Between the US and Europe',
    regionA: 'United States (EST/CST)',
    regionB: 'Europe (CET/BST)',
    ianaA: 'America/New_York',
    ianaB: 'Europe/Berlin',
    citiesA: 'New York / Chicago / Austin',
    citiesB: 'London / Berlin / Paris / Amsterdam',
    recommendedWindow: '09:00 AM – 01:00 PM EST (03:00 PM – 07:00 PM CET).',
    overlapType: 'High Overlap (3 to 4 hours of shared business time)',
    fairnessAdvice: 'This is one of the easiest transatlantic corridors. Keep core collaborative sessions between 10:00 AM and 12:00 PM EST.',
    contextCopy: '',
  },
  {
    slug: 'us-australia',
    h1: 'Best Meeting Times Between the US and Australia',
    regionA: 'United States (PST/EST)',
    regionB: 'Australia (AEST/AEDT)',
    ianaA: 'America/Los_Angeles',
    ianaB: 'Australia/Sydney',
    citiesA: 'San Francisco / New York',
    citiesB: 'Sydney / Melbourne / Brisbane',
    recommendedWindow: '04:00 PM – 07:00 PM PST (10:00 AM – 01:00 PM AEST next day).',
    overlapType: 'Opposite Day / Cross-Date Overlap',
    fairnessAdvice: 'Because Australia is 17-19 hours ahead of the US West Coast, US late afternoons land in Australia’s mid-morning of the following day.',
    contextCopy: '',
  },
  {
    slug: 'us-brazil',
    h1: 'Best Meeting Times Between the US and Brazil',
    regionA: 'United States (EST)',
    regionB: 'Brazil (BRT)',
    ianaA: 'America/New_York',
    ianaB: 'America/Sao_Paulo',
    citiesA: 'New York / Miami / Atlanta',
    citiesB: 'São Paulo / Rio de Janeiro / Brasília',
    recommendedWindow: '09:00 AM – 05:00 PM EST (11:00 AM – 07:00 PM BRT).',
    overlapType: 'Near-Full Overlap (1 to 2 hour difference)',
    fairnessAdvice: 'With almost total business hours alignment, nearshore Brazilian contractors can participate in normal team syncs without schedule strain.',
    contextCopy: '',
  },
  {
    slug: 'uk-india',
    h1: 'Best Meeting Times Between the UK and India',
    regionA: 'United Kingdom (GMT/BST)',
    regionB: 'India (IST)',
    ianaA: 'Europe/London',
    ianaB: 'Asia/Kolkata',
    citiesA: 'London / Manchester',
    citiesB: 'Mumbai / Bangalore / Hyderabad',
    recommendedWindow: '08:30 AM – 11:30 AM GMT (02:00 PM – 05:00 PM IST).',
    overlapType: 'High Overlap (3.5 hours of shared business time)',
    fairnessAdvice: 'Schedule calls during the UK morning. This captures the Indian team in their mid-afternoon before their workday concludes.',
    contextCopy: '',
  },
  {
    slug: 'europe-asia',
    h1: 'Best Meeting Times Between Europe and Asia',
    regionA: 'Europe (CET)',
    regionB: 'East Asia (SGT/JST)',
    ianaA: 'Europe/Berlin',
    ianaB: 'Asia/Singapore',
    citiesA: 'Berlin / Paris / Zurich',
    citiesB: 'Singapore / Tokyo / Hong Kong',
    recommendedWindow: '08:00 AM – 11:00 AM CET (03:00 PM – 06:00 PM SGT).',
    overlapType: 'Moderate Morning Overlap (2 to 3 hours)',
    fairnessAdvice: 'European teams should schedule calls first thing in the morning (08:00-09:00 CET) to catch Asian colleagues before their evening wrap-up.',
    contextCopy: '',
  },
  {
    slug: 'us-pakistan',
    h1: 'Best Meeting Times Between the US and Pakistan',
    regionA: 'United States (EST/PST)',
    regionB: 'Pakistan (PKT)',
    ianaA: 'America/New_York',
    ianaB: 'Asia/Karachi',
    citiesA: 'New York / San Francisco',
    citiesB: 'Karachi / Lahore / Islamabad',
    recommendedWindow: '08:00–10:00 AM EST (06:00–08:00 PM PKT) or 08:00 PM EST (06:00 AM PKT next day).',
    overlapType: 'Partial Overlap (2 to 3 hours window)',
    fairnessAdvice: 'For US East Coast teams, 8:00-10:00 AM EST aligns with evening in Pakistan (6:00-8:00 PM PKT). Use async updates for non-critical status items.',
    contextCopy: '',
  },
];

export function getMeetingCorridor(slug) {
  return MEETING_CORRIDORS.find(c => c.slug === slug) ?? null;
}
